import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { useRootStore } from 'hooks/rootStore'
import { hubspotChatStore } from 'store/hubspotChatStore'
import {
  installHubSpotChat,
  loadHubSpotWidget,
  refreshHubSpotWidget,
  removeHubSpotWidget,
} from 'config/hubspot'

/**
 * Drives the HubSpot chat widget. Renders nothing.
 *
 * Page targeting — which routes the widget appears on, including the A/V
 * meeting-room exclusion — is delegated to HubSpot's portal-side URL rules.
 * This controller only provides the minimal glue that HubSpot can't:
 * - injects/loads the widget (except in E2E);
 * - refreshes it on SPA navigation so HubSpot re-evaluates its URL targeting
 *   (the widget doesn't detect client-side route changes on its own);
 * - hides it during the pre-session quiz — a full-screen dialog HubSpot can't
 *   target because the URL doesn't change.
 */
export const HubSpotChatController = observer(function HubSpotChatController() {
  const rootStore = useRootStore()

  // Drives a refresh on SPA navigation so HubSpot re-checks its URL targeting.
  const routeTitle = rootStore.router.currentRoute?.title
  const shouldShow = !hubspotChatStore.isSuppressed

  useEffect(() => {
    installHubSpotChat()

    if (shouldShow) {
      loadHubSpotWidget()
      refreshHubSpotWidget()
    } else {
      removeHubSpotWidget()
    }
  }, [shouldShow, routeTitle])

  return null
})
